function vehicleLabel(vehicle) {
  if (!vehicle) {
    return '';
  }
  return vehicle.carLabel || vehicle.carNumber;
}

export default vehicleLabel;
